class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('cross-sell:trigger'));
    if (!document.body.classList.contains('overflow-hidden')) {
      document.body.classList.add('overflow-hidden')
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');

      let videoList = document.querySelector('video-list');
      if (videoList) { videoList.resetAndCloseVideos() }

      if (document.getElementById("PopupModal-upsell-variants") != undefined) {
        document.getElementById('PopupModal-upsell-variants').removeAttribute("open")
      }
    });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.querySelector('cart-drawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    // if Giftbox app enabled
    const giftboxRoot = document.getElementById('giftbox-root');
    if (giftboxRoot) {
      const gbIframe = giftboxRoot.querySelector('iframe');
      if (gbIframe) gbIframe.style.zIndex = '12';
    }
  }

  close() {
    document.dispatchEvent(new CustomEvent('cross-sell:close'));
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // if Giftbox app enabled
    const giftboxRootClose = document.getElementById('giftbox-root');
    if (giftboxRootClose) {
      const gbIframeClose = giftboxRootClose.querySelector('iframe');
      if (gbIframeClose) {
        setTimeout(() => { gbIframeClose.style.zIndex = '2147483000'; }, 500);
      }
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    cartdrawerFreeShippingNote();
    // buildRecommendProductsSlider();

    if (window.location.pathname == '/cart') { return }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawerMain'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    let cartItemSelectors = [];
    const shouldRenderCartItems = document.getElementById('main-cart-items') !== null;
    if (shouldRenderCartItems) {
      cartItemSelectors = [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-sidebar',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.cart-sidebar .js-contents',
        }
      ]
    }
    const cartDrawerSelectors = [
      {
        id: 'CartDrawerMain',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
    return cartDrawerSelectors.concat(cartItemSelectors);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.querySelectorAll('.quantity__input').forEach((input) => {
  input.addEventListener('focus', (e) => {
    e.target.select();
  });
});